class ListService {
  /**
   * Sort a list of objects based on a sort field and the given field value order
   * If a value in the list does not exist in the order list, it is sorted to the end
   *
   * @param {array} list The list of objects to sort
   * @param {string} sortField The property of the object to sort on
   * @param {array} order An ordered list of object property values
   */
  sortObjectList (list, sortField, order) {
    list.sort((value1, value2) => {
      let value1Index = order.indexOf(value1[sortField])
      let value2Index = order.indexOf(value2[sortField])
      value1Index = value1Index === -1 ? list.length : value1Index
      value2Index = value2Index === -1 ? list.length : value2Index
      return value1Index - value2Index
    })
  }
}

export const listService = new ListService()
